const paymentType = "checkoutcom:frames";

const getConfig = (root, kind = "config") => {
    const selector = `script[data-kind="${kind}"][type="application/json"]`;
    return [...root.querySelectorAll(selector)].map((script) => JSON.parse(script.textContent));
};

Alpine.data("SevenCheckoutComCreditCard", (element) => ({
    config: getConfig(element).at(-1),
    cardInvalid: false,

    init() {
        this.initSDK();
    },

    initSDK() {
        const script = document.createElement("script");
        script.src = "https://cdn.checkout.com/js/framesv2.min.js";
        document.head.appendChild(script); // You can also use document.body.appendChild(script);
        script.onload = () => this.sdkReady();
    },

    sdkReady() {
        const baseLocale = this.config.locale.split('_')[0].toUpperCase();
        let locale = baseLocale + '-' + baseLocale;

        if (locale === 'EN-EN' || locale === 'PL-PL' || locale === 'DA-DA' || locale === 'PT-PT' || locale === 'CS-CS' || locale === 'NB-NB') {
            locale = 'EN-GB';
        }

        Frames.init({
            publicKey: this.config.publicKey,
            localization: {
                "EN-US": "EN-GB"
            }[locale] ?? locale,
            schemeChoice: true,
            style: {
                base: this._getInputStyle()
            }
        });

        Frames.addEventHandler(
            Frames.Events.FRAME_VALIDATION_CHANGED,
            (event) => {
                const selector = `.form-control.${event.element}-frame ~ .invalid-feedback`;

                for (const el of document.querySelectorAll(selector)) {
                    el.classList.toggle("d-block", false);
                }

                if (event.isEmpty) {
                    document.querySelector(`${selector}.invalid-feedback-empty`).classList.toggle("d-block", true);
                } else if (!event.isValid) {
                    document.querySelector(`${selector}.invalid-feedback-invalid`).classList.toggle("d-block", true);
                }
            }
        );

        const tokenType = `${paymentType}:creditcard`;

        this._dispatchEvent("init", {
            tokenType,
            id: this.config.id,
            instance: Frames,
            tokenize: async () => {
                let token;
                this.cardInvalid = false;

                try {
                    token = (await Frames.submitCard()).token;
                } catch (e) {
                    this.cardInvalid = true;
                }

                return {
                    paymentToken: {
                        ...(token ? {nonce: token} : {}),
                        type: tokenType
                    }
                };
            },
            validate: () => {
                const isValid = Frames.isCardValid();
                this.cardInvalid = isValid;
                return isValid;
            }
        });
    },

    _dispatchEvent(name, {cancelable, bubbles, ...detail} = {}) {
        return element.dispatchEvent(new CustomEvent(`seven:checkoutcom:frames:${name}`, {
            detail,
            bubbles: bubbles ?? true,
            cancelable: cancelable ?? true
        }));
    },

    /*
     * Create a fake form-control to be able to get the styles from it.
     * After styles are computed, the fake input is removed.
     */
    _getInputStyle() {
        const fake = document.createElement("input");
        fake.classList.add("form-control");
        fake.classList.add("checkout-form-control");
        document.body.append(fake);

        const props = [
            "display",
            "width",
            "padding",
            "font-size",
            "font-weight",
            "font-family",
            "line-height",
            "color",
            "-webkit-appearance",
            "-moz-appearance",
            "appearance",
            "background-color",
            "background-clip",
            "border",
            "border-radius",
            "transition"
        ];

        const style = window.getComputedStyle(fake);

        const inputStyle = Array.from(style)
            .filter((property) => props.includes(property))
            .reduce(
                (acc, property) => ({
                    ...acc,
                    fontFamily: style.getPropertyValue("font-family"),
                    [property]: style.getPropertyValue(property)
                }),
                {}
            );

        fake.remove();
        return inputStyle;
    }
}));
